// @mui/material components
import { makeStyles } from '@mui/styles';
// @mui/icons-material
import ReceiptIcon from '@mui/icons-material/Receipt';

// core components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import Button from 'components/CustomButtons/Button.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { secondaryColor } from '@themes/defaultThemeProps';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { useGetTemplateDictionaryQuery } from 'api/parameter.api';
import { Visibility } from '@mui/icons-material';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  templateName: {
    color: secondaryColor[2],
    fontWeight: '600',
    valign: 'top',
  },
  templateDescription: {
    display: 'block',
    color: secondaryColor[0],
    fontWeight: '300',
  },
};

const useStyles = makeStyles(styles);

export default function TemplateDictionary(props) {
  const { data: templateDictionary } = useGetTemplateDictionaryQuery();

  const handleEditParameter = (index) => {
    props.history.push('/admin/templateeditor', {
      template: templateDictionary[index],
    });
  };

  const data = templateDictionary.map((entry, key) => {
    const parameterRow = {
      id: key,
      template: { name: entry.name, description: entry.description },
      actions: (
        <div className='actions-left'>
          <Button
            justIcon
            round
            simple
            onClick={() => handleEditParameter(key)}
            color='warning'
            className='edit'
          >
            <Visibility />
          </Button>{' '}
        </div>
      ),
    };
    return parameterRow;
  });

  const classes = useStyles();

  const formatTemplateCell = ({ value }) => {
    return (
      <div>
        <span className={classes.templateName}>{value.name}</span>
        <span className={classes.templateDescription}>{value.description}</span>
      </div>
    );
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color='primary' icon>
            <CardIcon color='primary'>
              <ReceiptIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Template Defaults</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              columns={[
                {
                  Header: 'Template',
                  accessor: 'template',
                  Cell: formatTemplateCell,
                  filter: 'parameter',
                  disableSortBy: true,
                  width: 200,
                },
                {
                  Header: 'Actions',
                  accessor: 'actions',
                  disableFilters: true,
                  disableSortBy: true,
                  width: 50,
                  style: {
                    marginTop: 0,
                    width: '10%',
                  },
                },
              ]}
              data={data}
              options={{
                pageSize: data.length,
              }}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
